// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"52f22bf7","239":"753b1804","453":"2c4cccce","455":"ba3d1b46"}[chunkId] + ".chunk.js";
};